<div class="modal-header">
  <button
    type="button"
    (click)="bsModalRef.hide()"
    class="close"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>
  <h4 class="modal-title">
    <strong>Cliente não recebeu o token em seu Celular?</strong>
  </h4>
</div>

<div class="modal-body">
  <ul>
    <li>Verifique se o número do celular foi digitado corretamente;</li>
    <li>Verifique as mensagens no WhatsApp e SMS e veja se o código chegou;</li>
    <li>
      Verifique se a rede do celular está ativa e o modo avião foi desativado;
    </li>
    <li>
      Se o sinal de rede estiver fraco, peça para procurar um lugar que tenha um
      sinal melhor.
    </li>
  </ul>
  <h4>
    Se mesmo assim o cliente ainda não conseguir receber seu Token, aguarde
    alguns minutos e tente reenviá-lo novamente.
  </h4>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-border-orange"
    (click)="bsModalRef.hide()"
  >
    Ok, entendi
  </button>
</div>
